import {
  BulkAction,
  Dialog,
  Sort
} from "@saleor/types";
import { stringify as stringifyQs } from "qs";



const permissionSiteSection = "/shop-staff";


export enum MembersListUrlSortField {
  name = "name",
  email = "email"
}
export type MembersListUrlSort = Sort<MembersListUrlSortField>;

export const permissionSiteDetailsPath = permissionSiteSection;

export type PermissionSiteDetailsUrlDialog =
  | "remove"
  | "assign"
  | "unassign"
  | "unassignError";
export type PermissionSiteDetailsUrlQueryParams = BulkAction &  MembersListUrlSort &
  Dialog<PermissionSiteDetailsUrlDialog>;

export const permissionSiteDetailsUrl = (
  params?: PermissionSiteDetailsUrlQueryParams
) =>
  permissionSiteSection+
  "?" +
  stringifyQs(params);
